import React, { Component } from "react";
import { connect } from "react-redux";
import WithRoutify from "../../../hoc/WithRoutify";
import Buttons from "../../../components/UI/Buttons";
// import TableGrid from "../../../components/UI/TableGrid";
import WithRouter from "../../../hoc/WithRouter";
import VisitsList from "../../EmployeeVisitContainer/VisitsList";
import { decryptString } from "../../../utils/commonUtils";
import OrganizationService from "../../../services/OrganizationService";
import AssignCompany from "../../../components/Modal/AssignCompany";
import PERMISSIONS from "../../../utils/AclPermissions";
import VisitsLIstNew from "../../EmployeeVisitContainer/NewUIVisitList/VisitsLIstNew";
import EmployeeService from "../../../services/EmployeeService";

/** Block new visits when the profile is not active (legacy status or profile_status). */
const isEmployeeInactiveForVisits = (employee) => {
  if (!employee) {
    return false;
  }
  const legacyInactive =
    employee.status === 0 ||
    employee.status === false ||
    employee.status === "0";
  const profileStatus = String(employee.profile_status || "").toLowerCase();
  const profileInactive = ["inactive", "archived", "transferred"].includes(
    profileStatus
  );
  return legacyInactive || profileInactive;
};

class VisitHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Add any default state properties here if needed
      isModelOpen:false,
      assignCompanyModal:false,
      employeeRecord: null,
      filters: {
        first_name: "",
        last_name: "",
        gender: "",
        company_id: "",
        dob: "",
        patient_id: "",
        phone: "",
        identification_type: "",
        identification_number: "",
        clinic_id: "",
        booking_id: "",
        pre_registration_code: "",
      },
    };
  }

  componentDidMount =()=> {
    const { params } = this.props;
    // Fetch employee details to verify company assignment instead of relying on URL params
    this.checkEmployeeCompanyAssignment(params.patientId);
  }

  checkEmployeeCompanyAssignment = async (employeeId) => {
    try {
      const employeeData = await EmployeeService.getEmployee(employeeId);
      // Only show modal if employee doesn't have a company assigned
      // Check both company_assigned (should be 1) and company_id (should exist)
      if (employeeData && (employeeData.company_assigned === 0 || !employeeData.company_id)) {
        this.setState({ assignCompanyModal: true, employeeRecord: employeeData });
      } else {
        this.setState({ assignCompanyModal: false, employeeRecord: employeeData || null });
      }
    } catch (error) {
      console.error("Error checking employee company assignment:", error);
      // On error, don't show the modal
      this.setState({ assignCompanyModal: false, employeeRecord: null });
    }
  }

  companyAssignToogleHandler = () => {
    this.setState({assignCompanyModal: false});
    // Re-check after closing to ensure state is correct
    const { params } = this.props;
    this.checkEmployeeCompanyAssignment(params.patientId);
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (prevProps.params?.patientId !== params?.patientId && params?.patientId) {
      this.checkEmployeeCompanyAssignment(params.patientId);
    }
  }

  componentWillUnmount() {
    // Add any cleanup logic when the component is about to unmount
  }
  addVisitToogleHandler = () => {
    const { employeeRecord } = this.state;
    if (isEmployeeInactiveForVisits(employeeRecord)) {
      return;
    }
    const { params } = this.props;
    const patientDetails = decryptString(params.patientDetails);
    //patientDetails
    this.setState({
      isModelOpen:!this.state.isModelOpen,
      visitsAutoFillData:{
        company_id:patientDetails.company_id,
        employee_id:params.patientId,
        organization_id:OrganizationService.getOrgId(),
      }
    });
  }
  render() {
    const { params, isNewUI } = this.props;
    const { isModelOpen, visitsAutoFillData, assignCompanyModal, employeeRecord } =
      this.state;
    const patientDetails = decryptString(params.patientDetails);
    const employeeInactive = isEmployeeInactiveForVisits(employeeRecord);

    return (
      <div id="home" className="tab-pane active show" role="tabpanel">
        <div className="sh_innerPortview">
          <div className="p-2">
            <div className="sh_cardBox sh_chartboxht shadow-none border">
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <h6 className="text-sm mb-0">
                    Visits History - {patientDetails.patientName}
                  </h6>
                  <div className="addAction d-flex justify-content-between align-items-center">
                    <Buttons
                      title={"Add Physical / Drug Screen"}
                      className="btn btn-icon btn-transparent-dark"
                      acl={PERMISSIONS.VISITS.CREATE}
                      iconType={"AddIconDetailView"}
                      clickHandler={this.addVisitToogleHandler}
                      visitsAutoFillData={visitsAutoFillData}
                      disabled={employeeInactive}
                      disableButtonTitle={
                        employeeInactive
                          ? "Cannot add visits for an inactive patient"
                          : undefined
                      }
                    />
                  </div>
                </div>
              </div>

              {assignCompanyModal && (
                <AssignCompany
                  employeeId={params.patientId}
                  modleToogleHandler={this.companyAssignToogleHandler}
                />
              )}

              {isNewUI ? (
                <VisitsLIstNew
                  isModelOpen={isModelOpen}
                  isFromVisitHistory={true}
                  visitsAutoFillData={visitsAutoFillData}
                />
              ) : (
                <VisitsList
                  isModelOpen={isModelOpen}
                  isFromVisitHistory={true}
                  visitsAutoFillData={visitsAutoFillData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map Redux state to props
const mapStateToProps = (state) => ({
  isNewUI: state.common.isNewUI,
});

export default connect(mapStateToProps)(
  WithRouter(WithRoutify(VisitHistory))
);
